import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Menu from './Menu'
import { PHONE, PHONE_DISPLAY, EMAIL } from '../siteConfig'

// The whole item is the link, not just the value text — on small screens the
// text is hidden and only the icon remains, and it still has to be tappable.
const CONTACTS = [
    { key: 'mail', href: `mailto:${EMAIL}`, icon: 'icon-multimedia', label: 'Mail us', value: EMAIL },
    { key: 'call', href: `tel:${PHONE}`, icon: 'fa fa-phone', label: 'Call us', value: PHONE_DISPLAY },
];

function Header() {
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [sticky, setSticky] = useState(false);

    // Close the mobile menu on route change. This covers back/forward and the
    // logo link; tapping a menu item closes it directly via onNavigate, because
    // choosing the page you are already on leaves the pathname untouched and
    // would otherwise leave the panel open.
    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    // Sticky header, previously handled by the template's jQuery scroll handler.
    // Desktop sticks the nav strip; mobile sticks this row, which is where the
    // menu button now lives.
    useEffect(() => {
        const onScroll = () => setSticky(window.pageYOffset > 100);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <header className={`header-area${sticky ? ' is-sticky' : ''}`}>
            <div className="header-top">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="inner-content clearfix">
                                <div className="header-left float-left">
                                    <div className="logo">
                                        <a href="/">
                                            <img src={`${process.env.PUBLIC_URL}/images/resources/nutrism-logo.png`} alt="Nutrism"/>
                                        </a>
                                    </div>
                                </div>
                                <div className="header-middle clearfix float-right">
                                    <ul className="info-box">
                                        {CONTACTS.map((contact) => (
                                            <li key={contact.key}>
                                                <a
                                                    href={contact.href}
                                                    className="link-header info-link"
                                                    aria-label={`${contact.label}: ${contact.value}`}
                                                >
                                                    <div className="icon-holder">
                                                        <span className={`${contact.icon} thm-clr`}></span>
                                                    </div>
                                                    <div className="title-holder">
                                                        <h5>{contact.label}</h5>
                                                        <p>{contact.value}</p>
                                                    </div>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                    {/* Hidden above 991px by responsive.css's .navbar-toggle rule,
                                        where the nav strip below shows the links directly. */}
                                    <button
                                        type="button"
                                        className="navbar-toggle header-toggle"
                                        aria-expanded={menuOpen}
                                        aria-controls="main-navigation"
                                        aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
                                        onClick={() => setMenuOpen((open) => !open)}
                                    >
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Menu
                menuOpen={menuOpen}
                sticky={sticky}
                onNavigate={() => setMenuOpen(false)}
            ></Menu>
        </header>
    )
}

export default Header
